import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { AccountModel } from '@/core/Account/model/AccountModel';

export default {

    /**
     * @param {AuthFacebookConfig} params /core/Account/config/AuthConfigModel.js
     */
    apiConnectFacebook: function (params) {
        let url = ConfigManager.getApiUrl() + '/auth/login';
        let token = Account.getToken();
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            let accountModel = new AccountModel();
            accountModel.setDataFromApi(res.data);
            return accountModel;
        }));
    },
}
